import type { AdminUserRole } from '@shared/types';

/**
 * The lateral content-only role, expressed as an `allowRoles` list for route
 * guards / nav gating. It is admitted to the content surface REGARDLESS of the
 * tier ladder (its tier is 0). Centralized here so the router, the layout nav,
 * and any future content surface share one definition. Mirrors the lateral
 * member of the server's `CONTENT_MANAGEMENT_ROLES`.
 */
export const CONTENT_MANAGER_ONLY: readonly AdminUserRole[] = ['content_manager'];

/**
 * The landing route for a freshly-authenticated admin of a given role.
 *
 * `content_manager` is a lateral, content-only role with NO tier on the
 * ladder (see `shared/types.ts`), so it cannot see the dashboard. Where it
 * lands instead is the ACTIVE game's call — its admin manifest's
 * `landingPaths` (#817; e.g. a game's content list), passed in by the caller
 * via `landingPathsFor(activeGameId)`. Every other role, and any role the
 * game names no landing for, lands on the dashboard.
 *
 * Used by both the index redirect and the `RequireAdmin` "logged in but wrong
 * area" bounce, so a content manager who deep-links into a tier-gated page is
 * sent somewhere they can actually use rather than to /login.
 */
export function adminHomePath(
  role: AdminUserRole,
  landingPaths: Partial<Record<AdminUserRole, string>> = {},
): string {
  return landingPaths[role] ?? '/dashboard';
}
